import axios from 'axios';

export default {
    checkAvailability() {
        const options = {
            url: window.apiUrl + '/support-ticket-availability',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET',
        }
         
        return axios.request(options).then(function(response) {
             return response;
        }).catch(function(error) {
            console.log(error)
            return(error);
        });
    },
    getHelp(context) {
       var options = {
            url: window.apiUrl + '/help',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET',
        }
         
        return axios.request(options).then(function(response) {
             return response;
        }).catch(function(error) {
            console.log(error)
            return(error);
        });
    },
    getHelpPage(context, slug) {
       var options = {
            url: window.apiUrl + '/help-page?slug=' + slug,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET',
        }
         
        return axios.request(options).then(function(response) {
             return response;
        }).catch(function(error) {
            console.log(error)
            return(error);
        });
    },
    submitTicket(context, data) {

        var options = {
            url: window.apiUrl + '/support',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'POST'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });

    },
    getNewestResponse(context) {
       var options = {
            url: window.apiUrl + '/latest-support-response',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
 
    },
    getUnread(context) {
       var options = {
            url: window.apiUrl + '/support-tickets/unread',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    markAsRead(context, ticketId) {
       var options = {
            url: window.apiUrl + '/support-tickets/unread/' + ticketId,
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'PATCH'
        };
        return axios.request(options).then(function(response) {
            return response;        
        }); 
    },
    getTickets(context) {
       var options = {
            url: window.apiUrl + '/support-tickets',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
 
    },
    replyToTicket(context, data) {
    
       var options = {
            url: window.apiUrl + '/support-ticket/reply',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data: data,
            method: 'POST',
        }
         
        return axios.request(options).then(function(response) {
             return response;

        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            return(error);

        }); 
    }
}


// WEBPACK FOOTER //
// ./src/services/support/index.js